import {configureStore} from '@reduxjs/toolkit';
import organizationReducer from '../features/organizations/organizationSlice';
import tenantReducer from '../features/tenants/tenantSlice';
import usersReducer from '../features/users/usersSlice';
import sidekickReducer from '../features/sidekick/sidekickSlice';

export const store = configureStore({
    reducer: {
        users: usersReducer,
        organization: organizationReducer,
        tenant: tenantReducer,
        sidekick: sidekickReducer
    },
    devTools: true
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
